import { PropsWithChildren, useState } from 'react';
import { BUTTON_VARIANTS, IconButton } from 'ui/button';
import { MakeCopy } from 'ui/icons';
import { Subtitle2 } from 'ui/theme';
import { Tooltip } from 'ui/tooltip';
import { updateClipboard } from 'utils/clipboard';
import { API_CALL_SOURCE_TEST_ID } from '../StartNodeEditor.constants';
import { EntrySourceComponentProps } from '../StartNodeEditor.types';
import {
  API_ENDPOINT_TEXT_TEST_ID,
  API_ENDPOINT_URL_TEST_ID,
  LEARN_MORE_LINK_TEST_ID,
  tooltipText,
  TRIGGER_API_ENDPOINT,
} from './APICallEntrySource.constants';
import { Body, Code, Link, OpenNewWindowIcon } from './APICallEntrySource.styled';

export const APICallEntrySource = ({ children }: PropsWithChildren<EntrySourceComponentProps>) => {
  const [copyTooltipText, setCopyTooltipText] = useState(tooltipText.default);
  const [copyTooltipOpen, setCopyTooltipOpen] = useState(false);

  const handleCopyClick = () => {
    setCopyTooltipText(tooltipText.inProgress);
    // Copy the endpoint
    updateClipboard(`${window.location.origin}${TRIGGER_API_ENDPOINT}`)
      .then(() => setCopyTooltipText(tooltipText.success))
      .catch(() => setCopyTooltipText(tooltipText.error));
  };

  const showTooltip = () => setCopyTooltipOpen(true);

  const hideTooltip = () => {
    setCopyTooltipOpen(false);
    setCopyTooltipText(tooltipText.default);
  };

  return (
    <div data-test={API_CALL_SOURCE_TEST_ID}>
      <Subtitle2>API endpoint</Subtitle2>
      <Body data-test={API_ENDPOINT_TEXT_TEST_ID}>
        Add users to this journey with{' '}
        <Code data-test={API_ENDPOINT_URL_TEST_ID}>POST {TRIGGER_API_ENDPOINT}</Code>&nbsp;
        <Tooltip tooltipContent={copyTooltipText} open={copyTooltipOpen}>
          <IconButton
            variant={BUTTON_VARIANTS.SECONDARY}
            onClick={handleCopyClick}
            // Toggle tooltip with keyboard
            onBlur={hideTooltip}
            onFocus={showTooltip}
            // Toggle tooltip with mouse
            onMouseEnter={showTooltip}
            onMouseLeave={hideTooltip}
          >
            <MakeCopy />
          </IconButton>
        </Tooltip>
      </Body>
      <Link
        data-test={LEARN_MORE_LINK_TEST_ID}
        href="https://support.iterable.com/hc/articles/204780579-API-#trigger-a-journey"
        target="_blank"
      >
        Learn More <OpenNewWindowIcon isColorInherited={true} height={20} />
      </Link>
      {children}
    </div>
  );
};
